import { useTranslation } from 'react-i18next';
import StandardModal, { ModalButtonType } from '../../Fundamentals/Modal/StandardModal';
import helpers from '../../../Utils/helpers';

const ReactivateSubscriptionModal = ({ subscription, onConfirm, isLoading = false }) => {
    const { t } = useTranslation();

    return (
        <StandardModal
            title={t('reactivateSubscription.title')}
            type={ModalButtonType.SEND}
            onSubmit={onConfirm}
            isLoading={isLoading}
        >
            <dl className="d-flex flex-column gap-8">
                <div className="d-flex flex-row gap-4">
                    <dt className="bold">{t('common.package')}: </dt>
                    <dd>{subscription?.package?.name}</dd>
                </div>
                <div className="d-flex flex-row gap-4">
                    <dt className="bold">{t('common.tier')}: </dt>
                    <dd>{subscription?.tier?.name}</dd>
                </div>
                <div className="d-flex flex-row gap-4">
                    <dt className="bold">{t('common.startdate')}: </dt>
                    <dd>{helpers.formatDate(subscription?.bindingPeriod?.startDate)}</dd>
                </div>
                <div className="d-flex flex-row gap-4">
                    <dt className="bold">{t('common.enddate')}: </dt>
                    <dd>{helpers.formatDate(subscription?.bindingPeriod?.endDate)}</dd>
                </div>
            </dl>
        </StandardModal>
    );
};

export default ReactivateSubscriptionModal;

